import React from 'react';
import { Gift, ArrowRight, Palette, Bot, Library } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    icon: Palette,
    title: 'BONUS 1',
    subtitle: 'Pack Canva Editable',
    items: ['Clases visuales', 'Actividades editables'],
    highlight: 'Aumenta muchísimo el valor percibido',
    image: 'https://images.unsplash.com/photo-1626785774573-4b799315345d?q=80&w=800&auto=format&fit=crop'
  }, {
    icon: Bot,
    title: 'BONUS 2',
    subtitle: '100 Prompts para ChatGPT',
    items: ['Copy + paste', 'Clases, ejercicios, ideas'],
    highlight: 'Muy atractivo hoy',
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=800&auto=format&fit=crop'
  }, {
    icon: Library,
    title: 'BONUS 3',
    subtitle: 'Biblioteca Extra de Actividades',
    items: ['+100 actividades adicionales'],
    highlight: 'Refuerza la promesa principal',
    image: 'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?q=80&w=800&auto=format&fit=crop'
  }];
  return <section className="py-12 md:py-20 italian-cream" data-id="element-21">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-22">
        <div className="text-center mb-10 md:mb-14" data-id="element-23">
          <div className="inline-flex items-center justify-center gap-2 bg-amber-100 text-amber-700 px-3 py-1.5 rounded-full font-bold text-xs uppercase tracking-wider mb-4" data-id="element-24">
            <Gift className="w-4 h-4" data-id="element-25" />
            Gratis por el día de hoy
          </div>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-slate-900 mb-2" data-id="element-26">
            BONUS EXCLUSIVOS
          </h2>
          <p className="text-sm md:text-lg text-slate-600" data-id="element-27">
            (Incluidos hoy sin costo adicional)
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-10 md:mb-14" data-id="element-28">
          {bonuses.map((bono, idx) => <a href="#compra" key={idx} className="group block bg-white rounded-xl md:rounded-2xl overflow-hidden shadow-md border border-slate-200 hover:shadow-2xl transition-all hover:-translate-y-1 flex flex-col" data-id="element-29">
              <div className="relative h-36 md:h-44 overflow-hidden" data-id="element-30">
                <img src={bono.image} alt={bono.subtitle} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-31" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-transparent to-transparent" data-id="element-32" />
                <div className="absolute top-3 right-3 z-20 bg-red-600 text-white text-[10px] md:text-xs font-bold px-2.5 py-1 rounded shadow-md uppercase" data-id="element-33">
                  Gratis
                </div>
                <div className="absolute bottom-3 left-3 z-10 flex items-center gap-2" data-id="element-34">
                  <div className="w-9 h-9 md:w-10 md:h-10 bg-emerald-500 rounded-lg flex items-center justify-center text-white shadow-lg" data-id="element-35">
                    <bono.icon className="w-5 h-5" data-id="element-36" />
                  </div>
                  <span className="text-[10px] md:text-xs font-bold text-white tracking-wider bg-black/40 backdrop-blur-sm px-2 py-1 rounded" data-id="element-37">
                    🎁 {bono.title}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-6 flex-1 flex flex-col" data-id="element-38">
                <h3 className="text-base md:text-lg font-bold text-slate-900 mb-3 leading-tight" data-id="element-39">
                  {bono.subtitle}
                </h3>
                <ul className="space-y-1.5 mb-4 flex-1" data-id="element-40">
                  {bono.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-xs md:text-sm text-slate-600" data-id="element-41">
                      <span className="text-emerald-500 font-bold mt-0.5" data-id="element-42">
                        •
                      </span>
                      {item}
                    </li>)}
                </ul>
                <div className="bg-emerald-50 border-l-2 border-emerald-500 rounded-r-md p-2.5 md:p-3 mt-auto" data-id="element-43">
                  <p className="text-emerald-800 font-semibold text-xs md:text-sm leading-snug" data-id="element-44">
                    👉 {bono.highlight}
                  </p>
                </div>
              </div>
            </a>)}
        </div>

        <div className="max-w-3xl mx-auto bg-slate-900 text-white rounded-2xl p-6 md:p-8 text-center shadow-xl relative overflow-hidden" data-id="element-45">
          <div className="absolute top-0 left-0 w-full h-1 flex" data-id="element-46">
            <div className="flex-1 bg-[#008C45]" data-id="element-47" />
            <div className="flex-1 bg-white" data-id="element-48" />
            <div className="flex-1 bg-[#CD212A]" data-id="element-49" />
          </div>
          <p className="text-base md:text-xl font-medium mb-1" data-id="element-50">
            Valor total de los bonus:{' '}
            <span className="line-through text-slate-400" data-id="element-51">$60.000 ARS</span>
          </p>
          <p className="text-xl md:text-3xl font-bold text-amber-400" data-id="element-52">
            Incluidos hoy sin costo adicional
          </p>
        </div>
      </div>
    </section>;
}